import { render, staticRenderFns } from "./IconIntentRelaxed.vue?vue&type=template&id=3832ab92&"
import script from "./IconIntentRelaxed.vue?vue&type=script&lang=js&"
export * from "./IconIntentRelaxed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports